module.exports = true;



//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/core-js-pure/internals/is-pure.js
// module id = 37
// module chunks = 44